import { createContext, useContext } from 'react';

/** Mirrors collections routes: VOD vs Mixed vs Top 10. Known synchronously from the route wrapper. */
export type CollectionRouteKind = 'vod' | 'mixed' | 'top10';

export const CollectionRouteContext = createContext<CollectionRouteKind>('vod');

export function useCollectionRouteKind(): CollectionRouteKind {
  return useContext(CollectionRouteContext);
}
